import React from 'react';
import { connect } from 'react-redux'
import createReactClass from 'create-react-class';

import actions from '../../../../redux/actions'
import Loader from '../../../../common/components/notifications/Loader';
import Preferences from './share/Preferences';
import { GET_PLAYER_PREFERENCES } from '../../../../redux/data/types';
import config from '../../../../config';
import { getHasRequestPending } from '../../../../redux/data/selectors';

var EmbedAndShare = createReactClass({
    componentDidMount: function() {
        this.props.requestPreferences()
    },
    render: function () {
        const event = this.props.event
        const { preferences, clientID } = this.props;
        if (preferences.data === null || !!preferences.isResolving) return <Loader message="Fetching"/>;

        return (<div>
            <Preferences
                mode="event"
                event={event}
                preferences={preferences}
                clientID={clientID}
                actions={this.props.actions}
            />
        </div>);
    }
});

const mapStateToProps = state => {
    const preferences = {
        data: state.data.playerPreferences,
        isResolving: state.data.playerPreferences !== null && getHasRequestPending(state, [GET_PLAYER_PREFERENCES])
    }
    return { preferences }
}

const mapDispatchToProps = dispatch => {
    const requestPreferences = () => dispatch((dispatch, getState) => dispatch(actions.request.sendRequest({
        type: GET_PLAYER_PREFERENCES,
        postData: {
            clientID: getState().data.user.clientId
        },
        url: `${config.uris.public}Player/getPlayerPreference`
    })))
    return { requestPreferences }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedAndShare);
